import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";
import "../css/datePicker.css"

const DatePicker = ({ selected, setSelected }) => {
  return (
    <DayPicker 
      disabled={{ before: new Date() }}
      required
      animate
      mode="single"
      selected={selected}
      onSelect={setSelected}
      styles={{
        month_caption: { fontFamily: "Montserrat",  marginLeft: "0.6rem" },
      }}
    />
  );
};

export default DatePicker;
